export type StoredMeasurementEntry = {
    Calculated: string;
    Actual: string;
};

const EMPTY_STORED = JSON.stringify({
    Calculated: "",
    Actual: "",
} satisfies StoredMeasurementEntry);

function toStoredString(value: number | undefined): string {
    const num = Number(value) || 0;
    return num === 0 ? "" : String(num);
}

export function parseMeasurementAttributeValue(raw: unknown): {
    Calculated: number;
    Actual: number;
} {
    if (typeof raw !== "string" || !raw.trim().startsWith("{")) {
        return { Calculated: 0, Actual: 0 };
    }

    try {
        const parsed = JSON.parse(raw) as Partial<StoredMeasurementEntry>;
        return {
            Calculated: Number(parsed.Calculated) || 0,
            Actual: Number(parsed.Actual) || 0,
        };
    } catch {
        return { Calculated: 0, Actual: 0 };
    }
}

export function serializeMeasurementAttributeValue(entry: {
    Calculated?: number;
    Actual?: number;
}): string {
    return JSON.stringify({
        Calculated: toStoredString(entry.Calculated),
        Actual: toStoredString(entry.Actual),
    } satisfies StoredMeasurementEntry);
}

export function isEmptyMeasurementAttributeValue(value: string): boolean {
    return value === EMPTY_STORED;
}

/**
 * Prefer field Actual when set; otherwise fall back to EagleView/Calculated.
 * Do not use `Actual ?? Calculated` — Actual is often `0` after EV sync
 * (empty Actual serializes to 0), and `0 ?? x` stays 0.
 */
export function resolveMeasurementNumericValue(entry?: {
    Calculated?: number;
    Actual?: number;
} | null): number {
    return Number(entry?.Actual) || Number(entry?.Calculated) || 0;
}
